import { withNamespaces } from "react-i18next";
import { Badge, Card, CardBody, CardTitle, Col, Label, Row } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import {
    INTERNATIONAL_DATE_FORMAT
} from 'src/common/constants';
import { 
    GeocledianDeforestationRisks,
    GeocledianCountryRisks 
} from "src/modules/3rd-party-management/constants";

const Header = ({
    t,
    geoData = {}
}) => {
    const  {
        name,
        commodity,
        country_iso,
        area,
        country_risk,
        deforestation_risk,
        generation_date,

        raw_response
    } = geoData;

    const dateUtils = new DateUtils();

    const deforestationCheckNotNeeded = (country_risk === 'low' && commodity !== 'wood');

    return (
        <Card>
            <CardBody>
                <CardTitle tag="h5" className="mb-3">
                    {name}
                </CardTitle>

                <Row>
                    {!deforestationCheckNotNeeded && (
                        <Col sm="12" md="6" lg="3" className="mb-4">
                            <div className="d-flex">
                                <div className="avatar-sm me-3">
                                    <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                        <i className="ri-calendar-todo-fill"></i>
                                    </span>
                                </div>
                                <div className="flex-1 align-self-center overflow-hidden">
                                    <Label className="form-label">
                                        {t('Generation Time')}
                                    </Label>
                                    <p className="text-muted mb-0">
                                        {dateUtils.convertDateToDate(
                                            generation_date,
                                            INTERNATIONAL_DATE_FORMAT
                                        )}
                                    </p>
                                </div>
                            </div>
                        </Col>
                    )}

                    <Col sm="12" md="6" lg={!deforestationCheckNotNeeded ? '3' : '4'} className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-leaf-line"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Commodity')}
                                </Label>
                                <p className="text-muted mb-0">
                                    {t(commodity)}
                                </p>
                            </div>
                        </div>
                    </Col>

                    <Col sm="12" md="6" lg={!deforestationCheckNotNeeded ? '3' : '4'} className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-earth-fill"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Country')}
                                </Label>
                                <p className="text-muted mb-0">
                                    {`${t(raw_response?.properties?.entity)} (${country_iso})`}
                                </p>
                            </div>
                        </div>
                    </Col>

                    <Col sm="12" md="6" lg={!deforestationCheckNotNeeded ? '3' : '4'} className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-earth-fill"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Area')}
                                </Label>
                                <p className="text-muted mb-0">
                                    {area} ha
                                </p>
                            </div>
                        </div>
                    </Col>

                    <Col sm="12" md="6" lg={!deforestationCheckNotNeeded ? '3' : '4'} className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-calendar-event-line"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Production Start')}
                                </Label>
                                <p className="text-muted mb-0">
                                    {dateUtils.convertDateToDate(
                                        raw_response?.properties?.production_start,
                                        INTERNATIONAL_DATE_FORMAT
                                    )}
                                </p>
                            </div>
                        </div>
                    </Col>

                    <Col sm="12" md="6" lg={!deforestationCheckNotNeeded ? '3' : '4'} className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-calendar-check-line"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Production End')}
                                </Label>
                                <p className="text-muted mb-0">
                                    {dateUtils.convertDateToDate(
                                        raw_response?.properties?.production_end,
                                        INTERNATIONAL_DATE_FORMAT
                                    )}
                                </p>
                            </div>
                        </div>
                    </Col>

                    <Col sm="12" md="6" lg={!deforestationCheckNotNeeded ? '3' : '4'} className="mb-4">
                        <div className="d-flex">
                            <div className="avatar-sm me-3">
                                <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                    <i className="ri-bar-chart-line"></i>
                                </span>
                            </div>
                            <div className="flex-1 align-self-center overflow-hidden">
                                <Label className="form-label">
                                    {t('Country Risk')}
                                </Label>
                                <p className="mb-0">
                                    <Badge
                                        style={{
                                            backgroundColor: GeocledianCountryRisks[country_risk?.toLowerCase()]?.color
                                        }}
                                    >
                                        {t(GeocledianCountryRisks[country_risk?.toLowerCase()]?.title)}
                                    </Badge>
                                </p>
                            </div>
                        </div>
                    </Col>

                    {!deforestationCheckNotNeeded && (
                        <Col sm="12" md="6" lg="3" className="mb-4">
                            <div className="d-flex">
                                <div className="avatar-sm me-3">
                                    <span className="avatar-title bg-light rounded-circle text-primary font-size-24">
                                        <i className="ri-bar-chart-line"></i>
                                    </span>
                                </div>
                                <div className="flex-1 align-self-center overflow-hidden">
                                    <Label className="form-label">
                                        {t('Deforestation Risk')}
                                    </Label>
                                    <p className="mb-0">
                                        <Badge
                                            style={{
                                                backgroundColor: GeocledianDeforestationRisks[deforestation_risk?.toLowerCase()]?.color
                                            }}
                                        >
                                            {t(GeocledianDeforestationRisks[deforestation_risk?.toLowerCase()]?.title)}
                                        </Badge>
                                    </p>
                                </div>
                            </div>
                        </Col>
                    )}
                </Row>
            </CardBody>
        </Card>
    )
}

export default withNamespaces()(
    Header
);